import React from "react";
import './index.less';
import Content from "./components/content";
import Content1 from "./components/content1";
import Content2 from "./components/content2";
import Content3 from "./components/content3";
import AllElementsBanner from "./components/banner";
export default class AllElements extends React.Component{
    // eslint-disable-next-line no-useless-constructor
    constructor(props){
        super(props)
    }
    render(){
        return (
          <div>
            <AllElementsBanner />
            <Content />
            <Content1 />
            <Content2 />
            <Content3 />
          </div>
        );
    }
}